import React from 'react'

const Footer = () => {
  return (
    <>
    <footer
    id="section-footer"
    className="footer moto-section"
    data-widget="section"
    data-container="section"
    data-moto-sticky="{mode:'smallHeight', direction:'bottom', mobile: 0}"
  >
    <div
      className="moto-widget moto-widget-row row-fixed moto-justify-content_center moto-bg-color_custom3 moto-spacing-top-medium moto-spacing-right-auto moto-spacing-bottom-medium moto-spacing-left-auto"
      data-grid-type="sm"
      data-widget="row"
      data-visible-on="-"
      data-spacing="mama"
      style={{}}
      data-bg-position="left top"
      data-draggable-disabled=""
    >
      <div className="container-fluid">
        <div className="row" data-container="container">
          <div
            className="moto-widget moto-widget-row__column moto-cell col-sm-6 moto-spacing-top-auto moto-spacing-right-auto moto-spacing-bottom-auto moto-spacing-left-auto"
            style={{}}
            data-widget="row.column"
            data-container="container"
            data-spacing="aaaa"
            data-bg-position="left top"
          >
            <div
              className="moto-widget moto-widget-text moto-preset-default moto-spacing-top-small moto-spacing-right-auto moto-spacing-bottom-small moto-spacing-left-auto"
              data-widget="text"
              data-preset="default"
              data-spacing="sasa"
              data-visible-on="-"
              data-animation=""
              data-draggable-disabled=""
            >
              <div
                className="moto-widget-text-content moto-widget-text-editable"
                aria-multiline="true"
              >
                <p className="moto-text_system_10">
                  2024&nbsp;© All rights reserved. &nbsp; &nbsp;
                  {/* <a
                    target="_self"
                    href="privacy-policy/index.html"
                    data-action="page"
                    data-id={18}
                    className="moto-link"
                  >
                    Privacy Policy
                  </a> */}
                </p>
              </div>
            </div>
          </div>
          <div
            className="moto-widget moto-widget-row__column moto-cell col-sm-6 moto-spacing-top-auto moto-spacing-right-auto moto-spacing-bottom-auto moto-spacing-left-auto"
            style={{}}
            data-widget="row.column"
            data-container="container"
            data-spacing="aaaa"
            data-bg-position="left top"
          >
            <div
              id="wid_1595840854_kjd4m8lxl"
              data-widget-id="wid_1595840854_kjd4m8lxl"
              className="moto-widget moto-widget-social-links-extended moto-preset-2 moto-align-right moto-align-center_mobile-h moto-spacing-top-auto moto-spacing-right-auto moto-spacing-bottom-auto moto-spacing-left-auto  "
              data-widget="social_links_extended"
              data-preset={2}
            >
              <ul className="moto-widget-social-links-extended__list">
                <li className="moto-widget-social-links-extended__item moto-widget-social-links-extended__item-1">
                  <a
                    href="/"
                    className="moto-widget-social-links-extended__link"
                    target="_self"
                  >
                    <span className="moto-widget-social-links-extended__icon fa">
                      
                    </span>
                  </a>
                </li>
                <li className="moto-widget-social-links-extended__item moto-widget-social-links-extended__item-2">
                  <a
                    href="/"
                    className="moto-widget-social-links-extended__link"
                    target="_self"
                  >
                    <span className="moto-widget-social-links-extended__icon fa">
                      
                    </span>
                  </a>
                </li>
                <li className="moto-widget-social-links-extended__item moto-widget-social-links-extended__item-3">
                  <a
                    href="/"
                    className="moto-widget-social-links-extended__link"
                    target="_self"
                  >
                    <span className="moto-widget-social-links-extended__icon fa">
                      
                    </span>
                  </a>
                </li>
                <li className="moto-widget-social-links-extended__item moto-widget-social-links-extended__item-4">
                  <a
                    href="/"
                    className="moto-widget-social-links-extended__link"
                    target="_self"
                  >
                    <span className="moto-widget-social-links-extended__icon fa">
                      
                    </span>
                  </a>
                </li>
              </ul>
              <style
                type="text/css"
                dangerouslySetInnerHTML={{
                  __html:
                    "\n                                                        "
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
      
    </>
  )
}

export default Footer
